module.exports = __webpack_public_path__ + "img/reissue_allowance.2cbacb4b.png";